import { render, staticRenderFns } from "./DlvRL_Row_Action.vue?vue&type=template&id=35c6555f"
import script from "./DlvRL_Row_Action.vue?vue&type=script&lang=js"
export * from "./DlvRL_Row_Action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports